import React from "react";
import { C, font } from "../../lib/styles.js";
import ProspectsView from "./ProspectsView.jsx";
import FeedbackListView from "./FeedbackListView.jsx";

export default function WebsiteApp({ activeTab, user }) {
  if (activeTab === 0) return <ProspectsView user={user} />;
  if (activeTab === 1) return <FeedbackListView user={user} />;

  return (
    <div style={styles.placeholder}>
      <div style={styles.label}>Settings</div>
      <p>Settings not yet built.</p>
    </div>
  );
}

const styles = {
  placeholder: {
    background: C.surface,
    border: `1px solid ${C.border}`,
    borderRadius: 8,
    padding: 32,
    textAlign: "center",
    color: C.muted,
    fontSize: 13,
    fontWeight: 300,
    fontFamily: font,
  },
  label: {
    fontSize: 11,
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "0.12em",
    color: C.muted,
    marginBottom: 8,
  },
};
